<template>
  <div class="ren-decoration-cp ren-decoration-cp-service-guarantee" :style="cardStyle">
    <span v-if="items.length === 0">暂无保障项</span>
    <span v-for="item in items" :key="item">✓ {{ item }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const items = computed(() => {
  const value = props.component.props?.items
  if (!Array.isArray(value)) return []
  return value.map((item) => (typeof item === 'string' ? item : stringValue((item as Record<string, unknown>).title))).filter(Boolean)
})
const cardStyle = computed(() => {
  const color = stringValue(props.component.style?.cardColor)
  return color ? { backgroundColor: color } : undefined
})
</script>

<style scoped>
.ren-decoration-cp-service-guarantee {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 12px;
  font-size: 12px;
  color: var(--ren-theme-text);
}
</style>
